import { useNavigate, useSearchParams } from 'react-router';
import { useState } from 'react';
import { WAITING_PAGE } from '@/Router/routes';
import getClient from '@/api/getClient';
import getClientLoans from '@/api/getClientLoans';
import useCrossDomainLoginRedirect from './useCrossDomainRedirect';
import postClientCookies from '@/api/postClientCookies';
import useEventCollector from '@/hooks/context/EventCollector/useEventCollector';
import getClientEmail from '@/api/getClientEmail';
import getClientPhone from '@/api/getClientPhone';
import IdentifyEvent from '@/hooks/context/EventCollector/events/IdentifyEvent';
import { useSeon } from '@/hooks/useSeon';

export default function useHandleLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { crossDomainRedirect } = useCrossDomainLoginRedirect();
  const { identify } = useEventCollector();
  const [isLoading, setIsLoading] = useState(false);
  const { sendSeonFraudInfo } = useSeon();

  const handleLogin = async (
    from: 'Login' | 'TwoFA' | 'OneTimeTokenLogin' | 'NewPassword',
  ) => {
    setIsLoading(true);

    const [{ clientLoanCount }, client, email, phone] = await Promise.all([
      getClientLoans(),
      getClient(),
      getClientEmail(),
      getClientPhone(),
    ]);

    identify(
      new IdentifyEvent({
        phone,
        email,
        client,
      }),
    );

    if (clientLoanCount === 0) {
      await sendSeonFraudInfo();
    }

    setIsLoading(false);

    // If client has not finished registration process
    if (
      client &&
      (client.status === 'REGISTERED' || client.status === 'VALIDATED')
    ) {
      // Take user to registration app
      await crossDomainRedirect();
      return;
    }

    // Don't need to await this async function
    postClientCookies();

    //! Redirect feature - Is it needed?
    const redirectEncoded = searchParams.get('redirect');
    if (redirectEncoded) {
      const redirect = decodeURIComponent(redirectEncoded);
      navigate(redirect);
      return;
    }

    navigate(WAITING_PAGE, { state: { from } });
  };

  return { handleLogin, isLoading };
}
